import { render, staticRenderFns } from "./btn_notts.vue?vue&type=template&id=ada7d440&scoped=true"
import script from "./btn_notts.vue?vue&type=script&lang=js"
export * from "./btn_notts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada7d440",
  null
  
)

export default component.exports